import type * as Message from "./types/message"
import { request } from "@/utils/service"

const PREFIX = "teashop_merchant/"

/** 通过消息通知记录ID查询单条数据 */
export function getMessageById(merchantMessageRecordId: number) {
  return request<Message.MerchantMessageRecord>({
    url: `${PREFIX}merchant_message_record/${merchantMessageRecordId}`,
    method: "GET",
  })
}

/** 更新消息通知记录 */
export function updateMessage(data: Partial<Message.MerchantMessageRecord>) {
  return request<boolean>({
    url: `${PREFIX}merchant_message_record`,
    method: "PUT",
    data,
  })
}

/** 分页查询消息通知记录 */
export function getMessagePage(params: Partial<Message.MerchantMessageRecord>, current: number, size: number) {
  return request<Message.MessagePageListData>({
    url: `${PREFIX}merchant_message_record/page`,
    method: "GET",
    params: {
      ...params,
      current,
      size,
    },
  })
}

/** 查询店铺未读消息列表 */
export function getUnreadMessageListByShopId(shopId: number, current: number, size: number) {
  return request<Message.MessagePageListData>({
    url: `${PREFIX}merchant_message_record/unread/${shopId}`,
    method: "GET",
    params: {
      current,
      size,
    },
  })
}

/** 查询店铺所有消息列表 */
export function getMessageListByShopId(shopId: number, current: number, size: number) {
  return request<Message.MessagePageListData>({
    url: `${PREFIX}merchant_message_record/all/${shopId}`,
    method: "GET",
    params: {
      current,
      size,
    },
  })
}

/** 批量修改消息状态 */
export function batchUpdateMessageStatus(data: number[]) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}merchant_message_record/handle_batch`,
    method: "POST",
    data,
  })
}

/** 批量删除消息 */
export function deleteMessage(data: number[]) {
  return request<IApiResponseData<boolean>>({
    url: `${PREFIX}merchant_message_record/delete_batch`,
    method: "POST",
    data,
  })
}

/** 批量读取未读消息 */
export function batchReadMessage() {
  return request<IApiResponseData<void>>({
    url: `${PREFIX}merchant_message_record/batch/read`,
    method: "PUT",
  })
}

/** 批量删除已读消息 */
export function batchDeleteReadMessage() {
  return request<IApiResponseData<void>>({
    url: `${PREFIX}merchant_message_record/batch/delete`,
    method: "PUT",
  })
}
